import { useState, useEffect, useRef } from "react";
import { CSSTransition } from 'react-transition-group';




import FilterIcon from "../../assets/images/filter.svg";

import { useDispatch } from "react-redux";
import { editUserOverlay, suspendUser } from "../../store/actions/adminActions";


import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css


const DefaultColumnFilter = ({ name, column: { filterValue, setFilter, preFilteredRows, id } }) => {

    const [filterOpen, setFilterOpen] = useState(false);
    return (
        <div className="">
            {filterOpen ? (

                <>
                    <div className="flex items-center">
                        <img onClick={() => { setFilterOpen(!filterOpen); setFilter('') }} src={FilterIcon} alt="Filter Icon" className="w-4 h-4 mr-1" />
                        <input
                            value={filterValue || ''}
                            onChange={e => {
                                setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
                            }}
                            autoFocus
                            placeholder={`Search ${id}`}
                            style={{
                                width: '100%',
                                padding: '4px',
                                borderRadius: '5px',
                                fontWeight: 'normal'
                            }}
                        />
                    </div>
                </>
            ) : (
                <div className="flex items-center whitespace-nowrap">
                    <span>{name}</span>
                    <img onClick={() => setFilterOpen(!filterOpen)} src={FilterIcon} alt="Filter Icon" className="w-4 h-4 ml-2" />
                </div>
            )}
        </div>
    );
};


const CustomHeader = ({ column }) => {

    const hasFilter = column.hasFilter || false;
    return (
        hasFilter ? <DefaultColumnFilter name={column.title} column={column} /> : <div>{column.title}</div>

    );
};

const DropdownMenu = ({ user_id }) => {

    const dispatch = useDispatch();

    const suspendUserFN = () => {
        confirmAlert({
            message: 'Are you sure you want to suspend this user?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => dispatch(suspendUser(user_id))
                },
                {
                    label: 'No',
                    onClick: () => void(0)
                }
            ]
        });
    };


    return (
        <div className="relative left-15 top-[10px] w-38 bg-white rounded-md border border-[#3b3b3b] rounded-[5px] shadow-lg z-99999999999 dropdown-menu transition-opacity duration-3000 ease-in-out opacity-100">

            <div className="mt-1 p-2">
                <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black" onClick={() => { dispatch(editUserOverlay(user_id)); }}>
                    <i className="fas fa-edit"></i>
                    <span className="ml-2">Edit</span>
                </div>
                <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black" onClick={suspendUserFN}>
                    <i className="fas fa-ban"></i>
                    <span className="ml-2">Suspend</span>
                </div>

            </div>

        </div>
    );
};
const DropdownLabel = ({  user_id }) => {
    const [isOpen2, setIsOpen2] = useState(false);

    const dropdownRef = useRef(null);
    const openDropdownRef = useRef(null); // Ref to track the currently open dropdown


    const toggleDropdown = () => {
        if (openDropdownRef.current && openDropdownRef.current !== dropdownRef.current) {
            // Close the currently open dropdown
            openDropdownRef.current.setIsOpen2(false);
        }
        setIsOpen2(!isOpen2);
        if (!isOpen2) {
            openDropdownRef.current = { setIsOpen2, dropdownRef: dropdownRef.current }; // Update the ref to the current dropdown
        } else {
            openDropdownRef.current = null; // Reset if closing the current dropdown
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen2 && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen2(false);
                openDropdownRef.current = null; // Reset the open dropdown ref
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen2]);

    return (
        <div className="rounded-full cursor-pointer text-[#3b3b3b] dropdown-menu border border-[#3b3b3b] p-2 w-10 h-10 text-center" onClick={toggleDropdown} ref={dropdownRef}>
            <i className="fas fa-ellipsis-v"></i>
            <div className="absolute">
                <CSSTransition
                    in={isOpen2}
                    timeout={100}
                    classNames="slide-up"
                    unmountOnExit
                >
                    <DropdownMenu user_id={user_id} />
                </CSSTransition>
            </div>
        </div>
    );
};



/*
const statusBadge = (value) => {
    // Check if the value is 'Draft' or 'Approved' to set the font color
    const fontColor = (value === 'Draft' || value === 'Approved') ? 'text-customGreen' : 'text-customYellow';

    return (
        <div className={`badge ${fontColor} items-center overflow-hidden whitespace-nowrap text-ellipsis font-bold`}>
            <span>{value}</span>
        </div>
    )
}
*/




const cellRenderer = ({ value }) => {
    return <div className="p-2">{value}</div>
}


const columns = [
    {
        Header: CustomHeader,
        accessor: 'user_id',
        title: 'ID',
        Cell: cellRenderer
    },
    {
        Header: CustomHeader,
        accessor: 'last_name',
        title: 'Name',
        Cell: ({ row }) => `${row.original.first_name} ${row.original.last_name}`,
       // hasFilter: true

    },
    {

        Header: CustomHeader,
        accessor: 'email',
        title: 'Email',
        Cell: cellRenderer,
        //hasFilter: true
    },
    {

        Header: CustomHeader,
        accessor: 'role',
        title: 'Role',
        Cell: cellRenderer,
        //hasFilter: true
    },
    {

        Header: CustomHeader,
        accessor: 'status',
        title: 'Status',
        Cell: cellRenderer
    },
    {

        Header: CustomHeader,
        accessor: 'department_id',
        title: 'Department',
        Cell: ({ row }) => (
            <>
                {!row.original.department_name ? 'N/A' : row.original.department_name}
            </>
        )
    },
    {
        Header: CustomHeader,
        accessor: 'More',
        title: 'More',
        Cell: ({ row }) => (
            <>
                <DropdownLabel user_id={row.original.user_id} />
            </>
        )
    },
];



export default columns;
